import React, { Component } from 'react'
import Table from './table'

export default class Storage extends Component {

  render() {
    return (
      <div>
        <Table />
      </div>
    )
  }
}
